export const SHOW_FORM = 'formDialog/SHOW_FORM';
export const SUBMIT = 'formDialog/SUBMIT';
export const CANCEL = 'formDialog/CANCEL';
